export default class ClosebookActions {

  static NEW_DATA = 'NEW_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_DATA='ERROR_DATA';
  static BEFORE_CHECK='BEFORE_CHECK';
  static AFTER_CHECK='AFTER_CHECK';
  static BEFORE_SEARCH='BEFORE_SEARCH';
  static AFTER_SEARCH='AFTER_SEARCH';

  static beforeCheck(){
    return {
      type: ClosebookActions.BEFORE_CHECK
    };
  }
  static afterCheck(data){
    return {
      type: ClosebookActions.AFTER_CHECK,
      payload:data
    };
  }

  static beforeSearch(){
    return {
      type: ClosebookActions.BEFORE_SEARCH
    };
  }
  static afterSearch(data){
    return {
      type: ClosebookActions.AFTER_SEARCH,
      payload:data
    };
  }

  static error(error){
    return {
      type: ClosebookActions.ERROR_DATA,
      payload: error
    };
  }
  static reset(){
    return {
      type: ClosebookActions.NEW_DATA
    };
  }
  static success(){
    return {
      type: ClosebookActions.SUCCESS_DATA,
    };
  }
  
  static process(){
    return {
      type: ClosebookActions.PROCESS_DATA,
    };
  }
}